/**
 * Datas do calendário local no formato que a API e os <input> esperam.
 *
 * toISOString() devolve o dia em UTC: no Brasil (UTC−3), das 21h à meia-noite
 * isso já é o dia seguinte. Aqui a data sai de getFullYear/getMonth/getDate, ou
 * seja, do dia que o usuário vê no relógio.
 */

const pad = (n) => String(n).padStart(2, "0");

function valid(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
}

/**
 * Data local como 'YYYY-MM-DD' (hoje, sem argumento). Nulo ou inválido → null.
 */
export function localIsoDate(date = new Date()) {
  if (!valid(date)) return null;
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/**
 * O inverso do localIsoDate: 'YYYY-MM-DD' (ou o começo de um ISO, como o
 * "2026-10-07T00:00:00.000Z" das colunas de data) → Date à meia-noite local, sem
 * trocar o dia. Vazio → null.
 */
export function isoToDate(iso) {
  if (!iso) return null;
  const [y, m, d] = String(iso).split("T")[0].split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return valid(date) ? date : null;
}

/**
 * Data e hora locais como 'YYYY-MM-DDTHH:mm', o formato do
 * <input type="datetime-local">. Nulo ou inválido → null.
 */
export function localIsoDateTime(date = new Date()) {
  if (!valid(date)) return null;
  return `${localIsoDate(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
